<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Product Type"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="productTypes"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Product Types.</div>
      </template>

      <template #empty> No Related Product Types. Accounts found! </template>
      <template #loading>
        Loading Related Product Types. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true" headerStyle="width: 3em;">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column
        field="productTypeCode"
        header="Display Order"
        :sortable="true"
        headerStyle="width: 5em;"
      >
        <template #body="slotProps">
          {{
            slotProps.data.productTypeCode ? slotProps.data.productTypeCode : ""
          }}
        </template>
      </Column>
      <Column
        field="productTypeName"
        header="Description"
        :sortable="true"
        headerStyle="width: 20em;"
      >
        <template #body="slotProps">
          {{
            slotProps.data.productTypeName ? slotProps.data.productTypeName : ""
          }}
        </template>
      </Column>
      <Column
        field="expiryMonths"
        header="Expiry Months"
        :sortable="true"
        headerStyle="width: 6em;"
      >
        <template #body="slotProps">
          {{ slotProps.data.expiryMonths ? slotProps.data.expiryMonths : "" }}
        </template>
      </Column>
      <Column
        field="active"
        header="Active"
        :sortable="true"
        headerStyle="width: 7em;"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editProductTypes(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="productTypesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Product Type"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col p-col-9">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="productType.productTypeName"
          />
        </div>
        <div class="p-field p-col p-col-3">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="productType.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Expiry Month:</label>
          <InputNumber
            placeholder=""
            :disabled="false"
            :autoResize="true"
            :max="12"
            v-model="productType.expiryMonths"
          />
        </div>
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="productType.productTypeCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="productTypesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Product Types?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteProductTypes"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  opportunityService: null,
  data: () => ({
    productTypesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    productTypes: null,
    productType: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.productType = {};
      this.productTypesForm = true;
    },
    openConfirmation(data) {
      this.productType = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editProductTypes(data) {
      this.productType = data;
      this.productTypesForm = true;
    },
    async deleteProductTypes() {
      this.closeConfirmation();
      await this.opportunityService.deleteProductTypes(this.productType.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Product type removed",
        life: 5000
      });
      this.getAllProductTypes();
      this.getAllActiveProductTypesByHard();
    },
    save() {
      if (!this.productType.id) {
        this.opportunityService
          .postProductTypes(this.productType)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Product type added",
              life: 5000
            });
            this.getAllProductTypes();
            this.getAllActiveProductTypesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving product type",
              life: 5000
            });
          });
      } else {
        this.opportunityService
          .putProductTypes(this.productType, this.productType.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Product type updated",
              life: 5000
            });
            this.getAllProductTypes();
            this.getAllActiveProductTypesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating product type",
              life: 5000
            });
          });
      }
      this.productTypesForm = false;
    },
    getAllProductTypes() {
      this.loading = true;

      this.opportunityService
        .getAllProductTypesByHard()
        .then(data => {
          this.productTypes = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting product types",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "productTypes"'
          });
        });
    },
    getAllActiveProductTypesByHard() {
      this.opportunityService
        .getAllActiveProductTypesByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeproducttypes"'
          });
        });
    }
  },
  created() {
    this.opportunityService = new OpportunityService();
  },
  mounted() {
    this.getAllProductTypes();
  }
};
</script>
